import { Controller } from 'react-hook-form';
import { SelectInput, SelectOption } from './SelectInput';

type Props = {
  name: string;
  options: SelectOption[];
};

export default function ControlledSelectInput({ name, options }: Props): JSX.Element {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <SelectInput
          name={name}
          onChange={onChange}
          selected={options.find((option) => option.value === value)}
          options={options}
        />
      )}
    />
  );
}
